import {MegaphoneIcon, MicromorgiIcon} from '@/assets/icons/icons'
import {DonationType} from '@/features/recurring-gift/types'
import {replaceThousands} from '@/utilities/helpers'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {StyledPlanOfSubscription, StyledPlanOfSubscriptionContent, StyledPlanOfSubscriptionPartOfContent} from './style'
import {StyledPopoverContent, StyledTooltipBox} from '@/features/profile/components/membersip-plans/style'
import {Popover} from '@/components/ui/popover/Popover'
import {StyledInfoIcon} from '@/features/notifications/components/notificationIcon/style'
import {Translate} from '@/features/translation/components/translate/Translate'

type PlanOfSubscriptionProps = {
    plan: DonationType
    isSelected: boolean
    onSelectPlanHandler: () => void
    currencySymbol: string
    disabled?: boolean
    renderMegaphoneText?: () => React.ReactNode
    onClickTooltip?: (plan: DonationType) => void
    isActive?: boolean
    hasCoupon?: boolean
    nestingLevel?: 0 | 1
}

export const PlanOfSubscription: FC<PlanOfSubscriptionProps> = ({
    plan,
    isSelected,
    currencySymbol,
    onSelectPlanHandler,
    disabled = false,
    renderMegaphoneText = () => <></>,
    onClickTooltip,
    isActive = false,
    hasCoupon = false,
    nestingLevel = 0
}) => {
    const {t} = useTranslation()
    const isInnerElement = nestingLevel > 0
    const calculatePrice = (price: number) =>
        Math.round(price * (1 - (plan.discount ? +plan.discount.discount_percentage : 0)))
    return (
        <>
            <StyledPlanOfSubscription
                disabled={disabled || hasCoupon}
                onClick={!disabled && !isActive ? onSelectPlanHandler : undefined}
                isSelected={isSelected}
                extraContent={t('rookie_my_profile:membership:current_plan')}
                isActive={!hasCoupon && isActive}
                hasCoupon={hasCoupon}
                isInnerElement={isInnerElement}
                extraDiscountContent={
                    !isInnerElement
                        ? t('rookie_my_profile:membership:we_have_a_promotion_for_you')
                        : t('rookie_my_profile:membership:for_percentage_off', {
                              PERCENTAGE: plan.discount ? +plan.discount?.discount_percentage * 100 : 0
                          })
                }
            >
                <StyledPlanOfSubscriptionContent>
                    <StyledPlanOfSubscriptionPartOfContent>
                        <span>
                            <span className={`amount ${hasCoupon || isInnerElement ? 'line' : ''}`}>
                                <MicromorgiIcon height={31} width={32} />
                                <h1>{plan.amount}</h1>
                            </span>
                            {isInnerElement && (
                                <span className={`amount`}>
                                    <MicromorgiIcon height={31} width={32} />
                                    <h1>{calculatePrice(plan.amount)}</h1>
                                </span>
                            )}
                        </span>
                        <span className="column">
                            {isInnerElement && (
                                <span className={`price`}>
                                    {t('configure_membership_plans_modal:plan_price_for_month', {
                                        CURRENCY: currencySymbol,
                                        AMOUNT: Number(replaceThousands(calculatePrice(plan.dollar_amount)))
                                    })}
                                </span>
                            )}
                            <span className={`price ${hasCoupon || isInnerElement ? 'line' : ''}`}>
                                {t('configure_membership_plans_modal:plan_price_for_month', {
                                    CURRENCY: currencySymbol,
                                    AMOUNT: replaceThousands(plan.dollar_amount)
                                })}
                            </span>
                        </span>
                    </StyledPlanOfSubscriptionPartOfContent>
                    <div>
                        <span className={`${hasCoupon ? 'line' : ''}`}>
                            <MegaphoneIcon height={23} width={21} stroke={'#433C92'} />
                            <p>{renderMegaphoneText()}</p>
                        </span>
                        <StyledTooltipBox>
                            {plan.group.description && (
                                <div>
                                    <Popover isModal={true} withArrow={true} trigger={<StyledInfoIcon />}>
                                        <StyledPopoverContent>
                                            <Translate isUseMainAppLanguage={true} content={plan.group.description} />
                                        </StyledPopoverContent>
                                    </Popover>
                                </div>
                            )}
                        </StyledTooltipBox>
                    </div>
                </StyledPlanOfSubscriptionContent>
            </StyledPlanOfSubscription>
            {hasCoupon && !disabled && (
                <PlanOfSubscription
                    plan={plan}
                    isSelected={isSelected}
                    currencySymbol={currencySymbol}
                    onSelectPlanHandler={onSelectPlanHandler}
                    renderMegaphoneText={renderMegaphoneText}
                    onClickTooltip={onClickTooltip}
                    disabled={false}
                    isActive={isActive}
                    nestingLevel={1}
                />
            )}
        </>
    )
}
